import assessmentApplicationSurveyReducer from "./assessmentApplicationSurveyReducer";

const qnrReducers = {
    assessmentApplicationSurvey: assessmentApplicationSurveyReducer
}

export default qnrReducers;